import { Component } from '@angular/core';
import { ShowSecretToggleComponent } from './show-secret-toggle.component';

@Component({
  selector: 'show-passcode-toggle',
  templateUrl: './show-secret-toggle.component.html',
})
export class ShowPasscodeToggleComponent extends ShowSecretToggleComponent {
  constructor() {
    super();
    this.label = 'Show/hide passcode';
    this.iconClass = 'passcode-toggle';
    this.dataTestID = 'button-passcode-toggle';
  }
}
